/*
 Top level component, it renders everything else
 */

import React from 'react'
import store from "../store/store"
import { Provider } from "react-redux"
import Configurator from './Configurator'

const App = (props) => {
    return (
       <Provider store={store}>
           <Configurator languages={props.languages} currencies={props.currencies} products={props.products} categories={props.categories}/>
       </Provider>
    )
};

export default App;